import React from 'react';
import { Info, ChevronDown, ChevronUp } from 'lucide-react';

interface PriceBreakdownWrapperProps {
  title?: string;
  children: React.ReactNode;
}

export function PriceBreakdownWrapper({ title = "Prix moyens constatés", children }: PriceBreakdownWrapperProps) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const handleToggle = (e: React.MouseEvent) => {
    // Empêcher la propagation ET le comportement par défaut
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="mt-4 bg-gray-50 dark:bg-gray-700/30 rounded-xl p-4 sm:p-6">
      <div 
        onClick={handleToggle}
        className="flex items-start sm:items-center gap-2 mb-4 cursor-pointer"
      >
        <Info className="hidden sm:block w-4 h-4 text-gray-500 dark:text-gray-400 flex-shrink-0 mt-0.5 sm:mt-0" />
        <p className="text-sm text-gray-600 dark:text-gray-400 flex-1">
          {title}
        </p>
        <button
          type="button" // Spécifier explicitement que c'est un bouton de type button
          onClick={handleToggle}
          className="p-1 text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-full"
        >
          {isExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </button>
      </div>

      <div className={`overflow-hidden transition-all duration-300 ${
        isExpanded ? "max-h-[800px] opacity-100" : "max-h-0 opacity-0"
      }`}>
        {children}
      </div>
    </div>
  );
}